import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=022ecba8&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=ts"
export * from "./InputDate.vue?vue&type=script&lang=ts"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=022ecba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022ecba8",
  null
  
)

export default component.exports